module.exports = __webpack_public_path__ + "img/antes_despues_288.cc008364.png";